package de.ohhhmhhh.frontend.admin.ui.components.inputs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.benasher44.uuid.uuid4
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.step
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLFieldSetElement

@Composable
fun PriceInput(
    title: String,
    value: Int?,
    placeholder: Int? = null,
    id: String = remember { uuid4().toString() },
    attrs: AttrBuilderContext<HTMLFieldSetElement> = {},
    onChange: (Int) -> Unit = {}
) {
    Fieldset({
        attrs()
    }) {
        Label(forId = id, {
            classes("form-label")
        }) {
            Text(title)
        }
        NumberInput(min = 0) {
            id(id)
            classes("form-control")
            step(0.01)
            value?.also { defaultValue(formatCents(it)) }
            placeholder?.also { placeholder("$it") }
            onInput { event ->
                parsePriceToCents(event.target.value)?.also { onChange(it) }
            }
        }
    }
}

/** "19.99" -> 1999, "5" -> 500, "3.5" -> 350, ungültig/leer -> null */
private fun parsePriceToCents(input: String): Int? {
    val normalized = input.trim().replace(',', '.')
    if (normalized.isEmpty()) return null

    val match = Regex("""^(\d+)(?:\.(\d{0,2}))?$""").matchEntire(normalized) ?: return null
    val euros = match.groupValues[1].toLongOrNull() ?: return null
    val cents = match.groupValues[2].padEnd(2, '0').toInt()

    val total = euros * 100 + cents
    return if (total <= Int.MAX_VALUE) total.toInt() else null
}

/** 1999 -> "19.99" (Format, das <input type="number"> erwartet) */
private fun formatCents(cents: Int): String =
    "${cents / 100}.${(cents % 100).toString().padStart(2, '0')}"